import { render, staticRenderFns } from "./CollectionsSelect.vue?vue&type=template&id=c2a5dc36"
import script from "./CollectionsSelect.vue?vue&type=script&lang=js"
export * from "./CollectionsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports